import './Divider.css'

import { clsx } from 'clsx'
import type { ReactElement } from 'react'

interface DividerProps {
  direction?: 'horizontal' | 'vertical'
  className?: string
  id?: string
}

export const Divider = ({
  direction = 'horizontal',
  className,
  id,
}: DividerProps): ReactElement => (
  <hr aria-orientation={direction} className={clsx('doss-divider', className, direction)} id={id} />
)
